
.body {
  /* padding: 2rem; */
  width: 100%;
}

.section {
  display: flex;
}

.switchLabel {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.checkLabel {
  cursor: pointer;
  display: flex;
  gap: 0.5rem;
}
.alert {
  margin: 1rem;
}

.smallInput {
  width: 6rem;
}
.aspectLabel {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.boxemPrintBanner {
  width: 100%;
  padding: 10px 40px 0 10px;
  border-radius: 10px;
  background-color: var(--static-background-weak);
  border: 1px solid var(--static-divider-standard);
  margin-bottom: 2rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.formGroup {
  width: 600px;
  display: flex;
  flex-direction: column;;
  padding: 1rem;
  border-radius: 10px;
  background-color: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  margin: 1rem;
}

.labelSelectGroup {
  margin: 1rem 0;
}

.formGroupLabel {
  flex: 1 1 0;
  padding: 1rem;
  margin: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.formInputLabel {
  margin-bottom: 0.5rem;
}

.labelSizeOrientationGrid {
  display: grid;
  grid-template-columns: max-content 3fr min-content;
  column-gap: 10px;
  row-gap: 10px;
  align-items: center;
}

.inputGroup {
  padding: 1rem 0 1rem 1rem;
  border: 1px solid var(--static-divider-standard);
  border-radius: 10px;
}

.switchesRow {
  padding: 10px;
  border-bottom: 1px solid var(--static-divider-standard);
  margin: 10px;
}

.downloadModalBody {
  padding: 3rem 1rem 1rem 1rem;
}

.downloadPlatformRow {
  border: 1px solid var(--static-divider-standard);
  border-radius: 10px;
  margin: 10px;
}

.downloadPlatformIconSection {
  padding: 40px;
  flex: 1 0 0;
}

.downloadArchColumn {
  flex: 1 0 0;
  border-left: 1px solid var(--static-divider-standard);
}

.downloadArchRow {
  padding: 15px;
}

.downloadArchRow:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard);
}

.downloadLink {
  color: inherit;
}
.downloadLink:hover {
  color: inherit;
}
